module.exports = {
	"id": "ZA",
	"name": "South Africa",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.03069,
			"12": 0.00279,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": 0.01116,
			"19": null,
			"20": null,
			"21": 0.01674,
			"22": 0.00558,
			"23": 0.00279,
			"24": null,
			"25": 0.00558,
			"26": 0.04464,
			"27": 0.00279,
			"28": 0.00558,
			"29": 0.01116,
			"30": null,
			"31": 0.03069,
			"32": 0.00558,
			"33": 0.01674,
			"34": 0.01395,
			"35": 0.01116,
			"36": 0.0279,
			"37": 0.00837,
			"38": 0.01953,
			"39": 0.03069,
			"40": 0.08649,
			"41": 0.01953,
			"42": 0.01395,
			"43": 0.10881,
			"44": 0.03069,
			"45": 0.02511,
			"46": 0.06417,
			"47": 0.05022,
			"48": 0.05301,
			"49": 0.64449,
			"50": 0.09207,
			"51": 0.21762,
			"52": 0.23994,
			"53": 9.36045,
			"54": 2.28501,
			"55": 0.03069,
			"56": 0.01116,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.01395,
			"4": 0.00558,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": 0.00558,
			"11": 0.00279,
			"12": 0.00558,
			"13": null,
			"14": null,
			"15": 0.00279,
			"16": 0.00558,
			"17": null,
			"18": 0.00558,
			"19": 0.03906,
			"20": 0.01395,
			"21": null,
			"22": 0.00558,
			"23": null,
			"24": 0.00279,
			"25": 0.00558,
			"26": null,
			"27": null,
			"28": 0.00558,
			"29": 0.00837,
			"30": 0.01674,
			"31": 0.00558,
			"32": 0.00279,
			"33": 0.00558,
			"34": 0.0279,
			"35": 0.00837,
			"36": 0.01395,
			"37": 0.00837,
			"38": 0.03069,
			"39": 0.02232,
			"40": 0.03627,
			"41": 0.01953,
			"42": 0.01674,
			"43": 0.09207,
			"44": 0.04743,
			"45": 0.04743,
			"46": 0.0558,
			"47": 0.27063,
			"48": 0.23436,
			"49": 2.13714,
			"50": 0.11718,
			"51": 0.00837,
			"52": null,
			"3.5": null,
			"3.6": 0.00837
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": 0.00279,
			"29": 0.00279,
			"30": 0.00837,
			"31": null,
			"32": 0.00558,
			"33": 0.00837,
			"34": 0.01395,
			"35": 0.02511,
			"36": 0.02511,
			"37": 0.18135,
			"38": 0.01116,
			"39": 0.01674,
			"40": 0.18135,
			"41": 0.02511,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": 0.01674,
			"12.1": 0.18135
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": 0.01116,
			"6": 0.00837,
			"7": 0.01953,
			"8": 0.07533,
			"9": 0.08649,
			"10": 0.42687,
			"3.1": null,
			"3.2": null,
			"5.1": 0.0279,
			"6.1": 0.01674,
			"7.1": 0.05859,
			"9.1": 0.31527
		},
		"ios_saf": {
			"8": 0,
			"10": 3.0015992423,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.080889626353,
			"8.1-8.4": 0.149440157161,
			"9.0-9.2": 0.07129255204,
			"9.3": 1.08766842215
		},
		"android": {
			"3": 0,
			"4": 0.0653371317829,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00816714147287,
			"4.1": 0.235680368217,
			"4.2-4.3": 0.589200920543,
			"4.4": 1.35107854651,
			"4.4.3-4.4.4": 1.36274589147
		},
		"ie": {
			"6": 0.00837,
			"7": 0.02232,
			"8": 0.34038,
			"9": 0.31248,
			"10": 0.3348,
			"11": 3.63258,
			"5.5": null
		},
		"op_mob": {
			"0": 2.09528791238,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.0582024420106
		},
		"edge": {
			"12": 0.10602,
			"13": 0.37944,
			"14": 0.58869
		},
		"ie_mob": {
			"10": 0.358265915493,
			"11": 1.45865408451
		},
		"bb": {
			"7": 1.16081,
			"10": null
		},
		"samsung": {
			"0": 7.44072
		},
		"and_uc": {
			"0": 2.48745
		},
		"op_mini": {
			"0": 28.2294496456
		},
		"and_chr": {
			"0": 19.60921
		},
		"and_ff": {
			"0": 0.02884
		}
	},
	"total": 95.40666
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/ZA.json
 ** module id = 686
 ** module chunks = 0
 **/